import { getShareUrl } from "@utils/urlUtil";
import { getCurrPlat, plat } from "@utils/plat";

(function (S) {
    S.prototype.zjTrim = function () {
        return this.replace(/^\s+|\s+$/g, "");
    };
    S.prototype.zjFill = function (args) {
        let s = this;
        if (args != null) {
            let r,
                type = Object.prototype.toString.call(args),
                arr = type == "[object Array]" || type == "[object Object]" ? args : arguments;
            for (let i in arr) {
                r = new RegExp("\\{" + i + "\\}", "gm");
                s = s.replace(r, arr[i]);
            }
        }
        return s;
    };
    S.prototype.zjReplace = function (oldStr, newStr) {
        let s = this,
            i = 0;
        while ((i = s.indexOf(oldStr, i)) > -1) {
            s = s.substring(0, i) + newStr + s.substring(i + oldStr.length);
            i += newStr.length;
        }
        return s;
    };
})(String);

/**
 * 延时
 * @param {number} time 毫秒数
 * @returns
 */
export function sleep(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}

/**
 * @description 获取带用户授权/登录的连接
 * @param {string?} url 为null时 则默认获取当前的URL
 * @param {boolean?} mustLogin 是否必需登录，主要针对 app 和 有票有用
 * @param {int?} targetPlatId 目标渠道/平台ID，为null时 则默认获取当前渠道ID
 * @param {boolean?} getUserInfo 是否获取用户信息，目前只对微信有用（获取头像和昵称）
 * @return {string}
 */
export const getAuthUrl = function (url, mustLogin, targetPlatId, getUserInfo) {
    if (!url) url = location.href;

    let authUrl,
        platId = targetPlatId || getCurrPlat().id;
    if (platId == plat.app.id) {
        authUrl = url + (url.indexOf("?") > -1 ? "&" : "?") + "mid=tcwvmid";
        if (mustLogin) authUrl += "&tcwvclogin";
    } else if (platId == plat.yPiao.id) {
        authUrl = url;
    } else if (platId == plat.qq.id) {
        authUrl = location.protocol + "//app.ly.com/hcpzt/cube/common/jump2qq2?url={0}";
        authUrl = authUrl.zjFill(encodeURIComponent(url));
    } else if (platId == plat.wx.id) {
        url = "https://wx.17u.cn/flight/{0}.html?url={1}".zjFill(getUserInfo ? "getwxuserinfo" : "getopenid", encodeURIComponent(url));
        authUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3827070276e49e30&redirect_uri={0}&response_type=code&scope={1}&state=123#wechat_redirect";
        authUrl = authUrl.zjFill(encodeURIComponent(url), getUserInfo ? "snsapi_userinfo" : "snsapi_base");
    }
    return authUrl;
};

/**
 * @description 获取当前带授权的URL
 * @param {int?} toPlatId 目标渠道/平台ID，为null时 则默认获取当前渠道ID
 * @param {string?} searchArg 需要携带的URL参数，可以是string/key[]/{key:val}
 * @param {boolean?} mustLogin 是否必需登录，主要针对 app 和 有票有用
 * @param {boolean?} getUserInfo 是否获取用户信息，目前只对微信有用（获取头像和昵称）
 * @param {boolean?} hasHash 是否解析hash
 * @return {string}
 */
export const getLocalAuthUrl = function (toPlatId, searchArg, mustLogin, getUserInfo, hasHash) {
    let url = getShareUrl(searchArg, hasHash);

    return getAuthUrl(url, mustLogin, toPlatId, getUserInfo);
};
